import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Product} from "../model/product";
import {ProductCategory} from "../model/productCategory";
import 'rxjs/Rx';
import {DocumentClass} from "../model/documentClass";
import {map, tap} from "rxjs/operators";


@Injectable({
    providedIn: 'root'
})
export class ProductService {

    constructor(private httpClient: HttpClient) {
    }


    getProductsCommand(): Observable<Product[]> {
        const httpOptions = {
            withCredentials: true //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
        };
        return this.httpClient.get<Product[]>("/api/products", httpOptions);
    }

    getDocumentClassByShortname(shortName: string): Observable<DocumentClass> {
        const httpOptions = {
            withCredentials: true //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
        };

        const storageEntry: string | null = sessionStorage.getItem(shortName);
        if(storageEntry){
            return of(JSON.parse(storageEntry));
        }
        return this.httpClient.get<DocumentClass>("/api/documents/document-class/" + shortName, httpOptions);
    }

    getProductByCategoryCommand(options: {} = {}): Observable<Map<string, Product[]>> {
        options['withCredentials'] = true;
        return this.httpClient.get<Map<string, Product[]>>("/api/categories", options);
    }


    getProductByCategoryMapCommand(): Observable<Map<ProductCategory, Product[]>> {
        const httpOptions = {
            withCredentials: true //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
        };
        return this.httpClient.get<Map<ProductCategory, Product[]>>("/api/categoriesMap", httpOptions);
    }


    getProducts(): Observable<Array<Product>> {
        return new Observable((observer) => {
            let products: Array<Product> = JSON.parse(sessionStorage.getItem("products"));

            if (!products) {
                this.getProductsCommand().subscribe(
                        res => {
                            products = res;
                            sessionStorage.setItem("products", JSON.stringify(products));
                            observer.next(products);
                        },
                        error => {
                            console.log("error", error);
                            observer.error(error);
                        }
                );
            } else
                observer.next(products);
        });
    }


    /**
     * Get all products by their categories either from the sessionStorage or from the API if not present in the sessionStorage.
     * If the products where not present they will be written to the sessionStorage.
     */
    public getProductByCategory(options: {} = {}): Observable<Map<string, Product[]>> {
        let productsMap: Map<string, Product[]> = JSON.parse(sessionStorage.getItem("categories"));

        if (productsMap) {
            return of(productsMap); // Emit the productsMap immediately as an observable
        } else {
            return this.getProductByCategoryCommand(options).pipe(
                    tap((res) => {
                        productsMap = res;
                        sessionStorage.setItem("categories", JSON.stringify(productsMap));
                    }),
                    map(() => productsMap) // Emit the productsMap synchronously
            );
        }
    }


    getProductByCategoryMap() {
        let productsCategoryMap: Map<ProductCategory, Product[]> = JSON.parse(sessionStorage.getItem("categoriesMap"));

        if (!productsCategoryMap) {
            this.getProductByCategoryMapCommand().subscribe(
                    res => {
                        productsCategoryMap = res;
                    },
                    error => {
                        console.log("error", error);
                    }
            );
        }
        return productsCategoryMap;
    }


    getInfoProductCommand(name) {

        const headers: HttpHeaders = new HttpHeaders({'Accept': 'text/html'});

        return this.httpClient.get(`/api/productsInfos/${name}`, {headers: headers, responseType: 'text'});

    }


}
